import interceptorAxios from './InterceptorAxios';

const ServicioConsultaFacturacionLayout={
    
  paginacion(objeto){
      return interceptorAxios.post('/consultaFacturacionLayout/paginacion_layout.json',objeto);
  }
}
export default ServicioConsultaFacturacionLayout;